import { TemplateRef } from '@angular/core';

export interface INavigationMenuAction {
  title: string;
  icon: string;
  tempRef: TemplateRef<unknown>;
  onSelect?: () => void;
  isHideMobileTitle?: boolean;
}
